module.exports = __webpack_public_path__ + "static/img/RWA654-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA654-G_1.png
// module id = pcjL
// module chunks = 0